import configuration from '../../constants/Configuration';
import FineUploaderS3 from 'fine-uploader-wrappers/s3';
import appParameters from './AppParameters';
import audioUtils from './AudioUtils';
import exporterUtils from './ExporterUtils';

const exportUploader = {
    uploader: undefined,

    init() {
        var accessKey;
        var bucket;
        var acceptedString = 'application/json';
        var arg = {};

        arg.options = {};
        if (configuration.IS_PROD() == true) {
            accessKey = 'AKIAJYMW5PW6FZLDMV2Q';
            bucket = 'creaza-content-json';
        } else {
            accessKey = 'AKIAJW24ZO65AI7KR7BA';
            bucket = 'creaza-stage-content-json';
        }

        arg.options.autoUpload = true;
        arg.options.request = {endpoint: 'https://s3-eu-west-1.amazonaws.com/' + bucket, accessKey: accessKey, clockDrift: audioUtils.serverTimeOffset};
        arg.options.signature = {endpoint: '/ICSXapi/file/SignS3Policy'};
        arg.options.validation = {acceptFiles: acceptedString};

        arg.options.objectProperties = {
            key: function(fileId) {
                return 'Cartoonist/' + appParameters.currentUserId + '/export/' + this.getName(fileId);
            }
        };

        this.uploader = new FineUploaderS3(arg);
        this.uploader.on('complete', this.onComplete.bind(this));
        this.uploader.on('error', this.onFail.bind(this));
    },
    onComplete(type, name, state) {
        exporterUtils.uploadSuccess(type, name, state);
    },
    onFail() {
        exporterUtils.uploadError();
    },
    uploadFile(blob, title) {
        var blobWrapper = {blob: blob, name: title};

        this.uploader.methods.addFiles([blobWrapper]);
    }
};

export default exportUploader;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ExportUploader.js
 **/